/* Bundler-App-Landingpages (/a/bundles/…) im Pick&Mix-Look.
   Ergänzt das Fremd-DOM der App „Bundler – Product Bundles":
   - Karte ist Klickfläche (ersetzt den ausgeblendeten „Hinzufügen"-Button)
   - Count-Bubbles je Karte (wie Pick&Mix)
   - Sticky-Footer mit Auswahl-Zähler, Gesamtpreis und Scroll-zur-Zusammenfassung
   Die App re-rendert ihr Markup mehrfach; deshalb Event-Delegation und
   MutationObserver auf dem stabilen, serverseitig gerenderten
   .bundler-target-element statt Referenzen auf App-Knoten. */

(function () {
  'use strict';

  var SELECTED_LABEL = 'AUSGEWÄHLT';
  var VIEW_SELECTION_LABEL = 'AUSWAHL ANZEIGEN';

  function init() {
    var target = document.querySelector('.bndlr-landing-page.bundler-target-element');
    if (!target || !target.querySelector('.bndlr-mnm-available-products')) return false;

    /* Aktiviert die CSS-Regeln (Karten-CTA ausblenden, cursor:pointer) erst,
       wenn die Klickfläche wirklich funktioniert. */
    target.classList.add('bndlr-pm-enhanced');

    var footer = buildFooter(target);

    /* Karten-Klick → App-Button auslösen; Produktlinks (target=_blank)
       auf der Karte unterbinden, wie bei Pick&Mix. Delegation auf dem
       stabilen Container überlebt App-Re-Renders. */
    target.addEventListener('click', function (event) {
      var card = event.target.closest('.bndlr-mnm-available-products .bndlr-product');
      if (!card || !target.contains(card)) return;
      if (event.target.closest('select, input, label')) return;
      var addButton = card.querySelector('.bndlr-add-to-bundle');
      if (!addButton) return;

      event.preventDefault();
      if (!addButton.contains(event.target)) addButton.click();
    });

    /* Auswahl-Änderungen (und App-Re-Renders) beobachten. sync() schreibt nur
       bei tatsächlichen Änderungen ins DOM, damit der Observer nicht kreist. */
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        sync(target, footer);
      }, 60);
    }).observe(target, { childList: true, subtree: true, characterData: true });

    sync(target, footer);
    return true;
  }

  function buildFooter(target) {
    var footer = document.createElement('div');
    footer.className = 'bndlr-pm-footer';
    footer.hidden = true;

    var info = document.createElement('div');
    info.className = 'bndlr-pm-footer__info';

    var count = document.createElement('p');
    count.className = 'bndlr-pm-footer__count';

    var total = document.createElement('p');
    total.className = 'bndlr-pm-footer__total';

    info.appendChild(count);
    info.appendChild(total);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bndlr-pm-footer__btn';
    button.textContent = VIEW_SELECTION_LABEL;
    button.addEventListener('click', function () {
      var summary = target.querySelector('.bndlr-mnm-second-container');
      if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    footer.appendChild(info);
    footer.appendChild(button);
    document.body.appendChild(footer);
    return footer;
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function setHidden(el, hidden) {
    if (el.hidden !== hidden) el.hidden = hidden;
  }

  /* Mengen aus der „Ihr Abo"-Liste lesen und auf Karten-Bubbles + Footer spiegeln. */
  function sync(target, footer) {
    var quantities = {};
    var totalCount = 0;

    target.querySelectorAll('.bndlr-mnm-selected-products .bndlr-product').forEach(function (item) {
      var variantId = item.getAttribute('data-variant-id');
      var quantityEl = item.querySelector('.bndlr-product-quantity');
      var quantity = quantityEl ? parseInt(quantityEl.getAttribute('product-quantity'), 10) || 0 : 0;
      if (variantId) quantities[variantId] = (quantities[variantId] || 0) + quantity;
      totalCount += quantity;
    });

    target.querySelectorAll('.bndlr-mnm-available-products .bndlr-product').forEach(function (card) {
      var quantity = 0;
      card.querySelectorAll('.bndlr-select-variant option').forEach(function (option) {
        quantity += quantities[option.value] || 0;
      });

      var bubble = card.querySelector('.bndlr-pm-bubble');
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'bndlr-pm-bubble count-bubble count-bubble--lg';
        bubble.hidden = true;
        card.appendChild(bubble);
      }
      setText(bubble, String(quantity));
      setHidden(bubble, quantity === 0);
    });

    var totalEl = target.querySelector('.bndlr-mnm-total-price');
    var totalText = '';
    if (totalEl) {
      var clone = totalEl.cloneNode(true);
      clone.querySelectorAll('.sr-only, .bndlr-sr-only').forEach(function (el) { el.remove(); });
      totalText = clone.textContent.replace(/\s+/g, ' ').trim();
    }
    var totalOut = footer.querySelector('.bndlr-pm-footer__total');

    setText(footer.querySelector('.bndlr-pm-footer__count'), totalCount + ' ' + SELECTED_LABEL);
    setText(totalOut, totalText);
    setHidden(totalOut, totalText === '');
    setHidden(footer, totalCount === 0);
  }

  /* Die App rendert asynchron nach DOMContentLoaded — pollen bis das Grid da ist. */
  function waitForApp(triesLeft) {
    if (init() || triesLeft <= 0) return;
    setTimeout(function () { waitForApp(triesLeft - 1); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForApp(60); });
  } else {
    waitForApp(60);
  }
})();
